import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { ClientGroupModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { dictionaryRepositoryResponseHandler } from '../dictionary/dictionary-repository-response-handler';
import { ClientGroupBO } from './client-group.bo';

@Repository({
    boType: ClientGroupBO,
    apiController: {
        base: 'clients/groups',
        get: '/:externalId',
        put: '/:externalId',
        delete: '/:externalId',
        tags: [Tags.Api]
    },
    responseHandler: dictionaryRepositoryResponseHandler,
})
export class ClientGroupRepositoryBase extends RepositoryBase<ClientGroupBO, ClientGroupModel> {
    public constructor(
        private readonly http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): ClientGroupBO {
        return new ClientGroupBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: ClientGroupModel): Promise<any> {
        return {
            externalId: model.externalId,
            sun: model.sun,
            version: model.version,

            isDefault: model.isDefault,
            name: model.name
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<ClientGroupModel> {
        return new ClientGroupModel(pickBy({
            externalId: item.externalId,
            sun: item.sun,
            version: item.version,

            isDefault: item.isDefault,
            name: item.name
        }, val => val !== void 0));
    }
}
